import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M225.882353,1298.41176 C350.456471,1298.41176 451.764706,1399.72 451.764706,1524.29412 C451.764706,1648.86824 350.456471,1750.17647 225.882353,1750.17647 C101.308235,1750.17647 0,1648.86824 0,1524.29412 C0,1399.72 101.308235,1298.41176 225.882353,1298.41176 Z M1920,1411.35294 L1920,1637.23529 L677.647059,1637.23529 L677.647059,1411.35294 L1920,1411.35294 Z M225.882353,733.705882 C350.456471,733.705882 451.764706,835.014118 451.764706,959.588235 C451.764706,1084.16235 350.456471,1185.47059 225.882353,1185.47059 C101.308235,1185.47059 0,1084.16235 0,959.588235 C0,835.014118 101.308235,733.705882 225.882353,733.705882 Z M1920,846.647059 L1920,1072.52941 L677.647059,1072.52941 L677.647059,846.647059 L1920,846.647059 Z M225.882353,169 C350.456471,169 451.764706,270.308235 451.764706,394.882353 C451.764706,519.456471 350.456471,620.764706 225.882353,620.764706 C101.308235,620.764706 0,519.456471 0,394.882353 C0,270.308235 101.308235,169 225.882353,169 Z M1920,281.941176 L1920,507.823529 L677.647059,507.823529 L677.647059,281.941176 L1920,281.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBulletListSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBulletListSolid, _Component);

  var _super = _createSuper(IconBulletListSolid);

  function IconBulletListSolid() {
    _classCallCheck(this, IconBulletListSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBulletListSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBulletList",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconBulletListSolid.displayName = "IconBulletListSolid";
  return IconBulletListSolid;
}(Component);

IconBulletListSolid.glyphName = 'bullet-list';
IconBulletListSolid.variant = 'Solid';
IconBulletListSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBulletListSolid;
export { IconBulletListSolid };